import script from "./MenuBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuBar.vue?vue&type=script&setup=true&lang=ts"

import "./MenuBar.vue?vue&type=style&index=0&id=7095d038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7095d038"]])

export default __exports__